let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lv6Md")).then(() => parcelRequire('9AqbR'));